import { Button, Fade, Link, Modal } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { invalidateEmployeeToken } from "../../../services/api-services/eSignService";
import { clearAuthData } from "../../../services/authService";
import store from "../../../store";
import { showAlert } from "../../../store/actions/feedback";
import { ROUTES, VIEWS } from "../../constants/user-info.const";
import { AppContext } from "../../routing/Routing";
import Loader from "../Loader";

interface ModalProps {
  onClose: () => void;
}
export default function SendDetailsToEmployer(props: ModalProps) {
  const [showConfirmModal, setShowConfirmModal] = useState(true);
  const { onClose } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { setViewName } = useContext(AppContext);
  const navigate = useNavigate();

  const showErrorMessage = (error) => {
    let errorMessage;
    errorMessage = error?.errors?.payroll_org_errors?.message;
    if (!errorMessage) {
      errorMessage = error.status?.message;
    }
    store.dispatch(
      showAlert({
        alertType: "error",
        alertText: errorMessage,
      })
    );
  };
  const navigateToInfoSubmitted = () => {
    setViewName(VIEWS.infoSubmitted);
    navigate(ROUTES.infoSubmitted);
  };
  const submitToEmployer = () =>{
    setIsLoading(true);
    invalidateEmployeeToken().then(() =>{
      setIsLoading(false);
      navigateToInfoSubmitted();
      clearAuthData();
    })
    .catch((error) => {
      setIsLoading(false);
      showErrorMessage(error);
    });
  }
  return (
    <>
      {isLoading && <Loader />}
      {showConfirmModal && (
        <Modal open={showConfirmModal}>
          <Fade in={showConfirmModal}>
            <div className="e-sign__modal">
              <h4>Send Information to Employer? </h4>
              <p>
                In order to access this page again you will need to contact your
                employer.
              </p>
              <div className="e-sign__modal--footer">
                <Link
                  className="primary-link"
                  onClick={() => {
                    setShowConfirmModal(false);
                    onClose();
                  }}
                >
                  Cancel
                </Link>
                <Button
                  variant="contained"
                  className="btn-primary send-to-employer"
                  onClick={submitToEmployer}
                >
                  Send to Employer
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
      )}
    </>
  );
}
